import { render, staticRenderFns } from "./updateRecord.vue?vue&type=template&id=4288633f"
import script from "./updateRecord.vue?vue&type=script&lang=js"
export * from "./updateRecord.vue?vue&type=script&lang=js"
import style0 from "./updateRecord.vue?vue&type=style&index=0&id=4288633f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports